import "../styles/Banner.css"
function Banner({children}){
	return <div className="lmp-banner">{children}</div>
}
export default Banner